/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';
import { makeAsyncSelectors } from 'ui-lottery';
import facilities, { selectors as facilitiesSelectors } from './facilities';
import facility, { selectors as facilitySelectors } from './facility';
import passTypes, { selectors as passTypesSelectors } from './passTypes';
import facilityByIdOrSlug, {
    selectors as facilityByIdOrSlugSelectors,
} from './facilityByIdOrSlug';
import passType, { selectors as passTypeSelectors } from './passType';
import reservations, { selectors as reservationsSelectors } from './reservations';
import { passesReducers } from './passes';
import { localReservationReducers } from './localReservation';
import { reducer as validation, selectors as validationSelectors } from './validation';

// Generate the async selectors
const { isLoaded, isLoading, hasErrors, getErrors } = makeAsyncSelectors('parkpass');

// All of our Redux selectors
export {
    facilitiesSelectors,
    getErrors,
    hasErrors,
    isLoaded,
    isLoading,
    passTypeSelectors,
    passTypesSelectors,
    facilityByIdOrSlugSelectors,
    validationSelectors,
    reservationsSelectors,
    facilitySelectors,
};

const reducers = combineReducers({
    facilities,
    facility,
    passType,
    passTypes,
    facilityByIdOrSlug,
    validation,
    reservations,
    passes: passesReducers,
    localReservation: localReservationReducers,
});

export default reducers;
